import type { DifficultyLevel } from "./types";

export const DIFFICULTY_LABELS: Record<DifficultyLevel, string> = {
  easy: "Easy",
  medium: "Medium",
  hard: "Hard",
};

/** Inclusive planet-jump range per difficulty. */
export function planetCountRange(level: DifficultyLevel): { min: number; max: number } {
  switch (level) {
    case "easy":
      return { min: 1, max: 3 };
    case "medium":
      return { min: 1, max: 4 };
    case "hard":
      return { min: 1, max: 5 };
  }
}

export function randomPlanetCount(level: DifficultyLevel): number {
  const { min, max } = planetCountRange(level);
  return min + Math.floor(Math.random() * (max - min + 1));
}
